export const URL_ENDPOINTS = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL,
    SIGNATURE: process.env.REACT_APP_URL_API_ESIGNATURE + '/esignatures',
    SECURITY: process.env.REACT_APP_URL_API_SECURITY + '/token'
}